<template>
  <div class="package-details">
    <slot name="header"></slot>
    <template v-if="item.children && item.children.length > 0">
      <template v-for="(treeItem, idx) in item.children">
        <div class="product-item--wrapper children-list--cont"
             :key="'tree-instance-' + idx">
          <package-list :list-data="treeItem" :level="1"></package-list>
        </div>
      </template>
    </template>
    <!-- 非 树形菜单形状的 产品 -->
    <template v-if="item.productInstanceList && item.productInstanceList.length > 0">
      <template v-for="(instanceItem, idx) in item.productInstanceList">
        <div class="product-item--wrapper"
             :key="'package-instance-' + idx">
          <package-instance :item="instanceItem" is-leaf :level="1"></package-instance>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import PackageList from './PackageList'
import PackageInstance from './PackageInstance'

export default {
  name: 'PackageDetails',
  components: {
    PackageList,
    PackageInstance
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
  .package-details {
    background-color: rgba(31, 31, 31, 0.03) !important;
    padding: 8px 56px 8px 68px;
  }
</style>
